import { Box, Divider, IconButton, Tooltip } from "@mui/material";
import { colors } from "styles/colors";
import useGlobalStyles from "styles/globalStyles";
import { useNavigate } from "react-router-dom";
import GroupOutlinedIcon from '@mui/icons-material/GroupOutlined';
import ProfileSectionHeader from "components/common/ProfileSectionHeader/ProfileSectionHeader";
import PersonAddOutlinedIcon from '@mui/icons-material/PersonAddOutlined';
import RegistryCollaboratorsUsers from "../CreateRegistryForm/RegistryCollaboratorsUsers";

export default function RegistryCollaborators() {
  const globalStyles = useGlobalStyles();
  const navigate = useNavigate();

  return (
    <Box
      className={globalStyles.sectionContainer}
      sx={{
        flex: 1,
        display: "flex",
        flexDirection: "column",
        minHeight: 0,
        overflow: "hidden"
      }}
    >
      <Box px={2}>
        <ProfileSectionHeader
          title={'Collaborators'}
          icon={<GroupOutlinedIcon sx={{ fontSize: 20, color: colors.primary }} />}
          buttons={[
            <Tooltip title="Add Collaborators">
              <IconButton
                onClick={() => navigate("../edit", { relative: "path" })}
                sx={{
                  backgroundColor: colors.topBackground,
                  width: 32,
                  height: 32,
                  borderRadius: '4px',
                }}
              >
                <PersonAddOutlinedIcon
                sx={{
                  fontSize: 20,
                  color: colors.primary
                }}
                />
              </IconButton>
            </Tooltip>
          ]}
        />
      </Box>

      <Divider />

      <RegistryCollaboratorsUsers />

    </Box>

  );
}
